import React from 'react';
import definicoescliente from '../../definicoes-cliente.json';

const textData = {
    titulo: 'Baixe nosso aplicativo',
    LinkApple: 'https://apps.apple.com/br/app/sga-associado/id1450081121',
    LinkGoogle: 'https://play.google.com/store/apps/details?id=br.com.hinovamobile.sgaassociado',
    imagemSrc: '/images/aplicativo-1.png',
}

const ImagemTexto: React.FC = () => {

  return (
    <section id="download" className="text-center lg:px-14 bg-theme-gray py-12">
      <h2 className="text-textotitulo text-theme-dark font-bold mb-4">{definicoescliente?.Aplicativo?.Titulo || textData.titulo}</h2>
      <div className="items-center p-6">
        <img src={definicoescliente?.Aplicativo?.ImagemAplicativo || textData.imagemSrc} alt="Imagem App" className="mx-auto mb-4 object-cover max-h-[500px]"/>
        {/* Container dos botões */}
        <div className="flex justify-center space-x-4 mt-4">
          <a href={definicoescliente?.Aplicativo?.LinkApple || textData.LinkApple} target="_blank" rel="noopener noreferrer">
            <img src="/images/appstore.png" alt="Baixar na App Store" className="h-12"/>
          </a>
          <a href={definicoescliente?.Aplicativo?.LinkGoogle || textData.LinkGoogle} target="_blank" rel="noopener noreferrer">
            <img src="/images/googlestore.png" alt="Baixar no Google Play" className="h-12"/>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ImagemTexto;
